import React from "react";
import {FieldProps, useRecordContext} from "react-admin";

export const TextListField = (props: FieldProps & { source: string }) => {
  const record = useRecordContext(props);
  return <span>{record[props.source].join(", ")}</span>;
};
